"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var Layout = _interopRequireWildcard(require("./Layout"));
var _AdrMenu = _interopRequireDefault(require("../Menu/AdrMenu"));
var _AirturnMenu = _interopRequireDefault(require("../Menu/AirturnMenu"));
var _AodbMenu = _interopRequireDefault(require("../Menu/AodbMenu"));
var _Header = _interopRequireDefault(require("./Header"));
var _RealtimeMenu = _interopRequireDefault(require("../Menu/RealtimeMenu"));
var _TaskMenu = _interopRequireDefault(require("../Menu/TaskMenu"));
var _TimezoneContext = _interopRequireDefault(require("../_contexts/TimezoneContext"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var propTypes = {
  /** The project that is calling the component. Will determine the Menu
   * component and white label, as well as the menu items subscription. Defaults
   * to "aodb" */
  project: _propTypes["default"].oneOf(["adr", "aodb", "task", "airturn", "realtime"]),
  children: _propTypes["default"].node,
  // Callback function to be called when the user clicks on the logout button
  logout: _propTypes["default"].func,
  // The white label of the realm
  whiteLabel: _propTypes["default"].shape({
    src: _propTypes["default"].string,
    alt: _propTypes["default"].string,
    srcCollapsed: _propTypes["default"].string
  }),
  // Renders the menu components to the right of the header
  renderHeaderRight: _propTypes["default"].func,
  /** Menu items needs to be an array which can be passed to `MenuComponent`.
   *  It is very important that this array is memoized
   */
  menuItems: _propTypes["default"].array,
  /** The app's local timezone. Will fallback to "local" when not provided. */
  localTimezone: _propTypes["default"].string
};
var getProjectComponents = function getProjectComponents(project) {
  switch (project) {
    case "realtime":
      return _RealtimeMenu["default"];
    case "task":
      return _TaskMenu["default"];
    case "adr":
      return _AdrMenu["default"];
    case "airturn":
      return _AirturnMenu["default"];
    case "aodb":
    default:
      return _AodbMenu["default"];
  }
};
var PageWithMenu = function PageWithMenu(_ref) {
  var _ref$project = _ref.project,
    project = _ref$project === void 0 ? "aodb" : _ref$project,
    children = _ref.children,
    logout = _ref.logout,
    whiteLabel = _ref.whiteLabel,
    renderHeaderRight = _ref.renderHeaderRight,
    menuItems = _ref.menuItems,
    localTimezone = _ref.localTimezone;
  var MenuComponent = getProjectComponents(project);
  !MenuComponent && console.error("Missing MenuComponent for project", project);
  return /*#__PURE__*/_react["default"].createElement(_TimezoneContext["default"], {
    localTimezone: localTimezone
  }, /*#__PURE__*/_react["default"].createElement(Layout.Container, null, /*#__PURE__*/_react["default"].createElement(Layout.Menu, null, MenuComponent && /*#__PURE__*/_react["default"].createElement(MenuComponent, {
    menuItems: menuItems,
    whiteLabel: _objectSpread(_objectSpread({}, whiteLabel), {}, {
      alt: (whiteLabel === null || whiteLabel === void 0 ? void 0 : whiteLabel.alt) || "Logo"
    }),
    logout: logout
  })), /*#__PURE__*/_react["default"].createElement(Layout.Main, null, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    renderRight: renderHeaderRight
  }), children, /*#__PURE__*/_react["default"].createElement(Layout.Footer, null, "\xA9 AirportLabs Limited"))));
};
PageWithMenu.propTypes = propTypes;
var _default = PageWithMenu;
exports["default"] = _default;